import { useCallback, useState } from 'react';

import { useAppDispatch, useWidgetParam } from '@src/core/hooks';
import { restoreCartFromOrder } from '@src/features/cart/store/cart';

export const useRestoreCartFromOrder = () => {
  const dispatch = useAppDispatch();
  const landingPage = useWidgetParam('landing-page');
  const [restoring, setRestoring] = useState(false);

  const restore = useCallback(
    async (orderId: string) => {
      setRestoring(true);

      let redirecting = false;

      try {
        redirecting = await dispatch(restoreCartFromOrder(orderId, landingPage ?? ''));
      } finally {
        // Only a dead end releases the action: on the way out changeLocation takes the page, and
        // letting the button back in before that starts a second conversion of the same order. The
        // finally is what keeps an unexpected throw from leaving the button disabled for good.
        if (!redirecting) {
          setRestoring(false);
        }
      }
    },
    [dispatch, landingPage],
  );

  return { restore, restoring };
};

export default useRestoreCartFromOrder;
